import api from "../api/api";
import { buildFileUrl } from "./fileHelpers";
import environment from "./environment";

const DEFAULT_PREVIEW_EXPIRY_MINUTES = 15;

export const isAzureBlobUrl = (url = "") => {
  try {
    return new URL(url).hostname.endsWith(".blob.core.windows.net");
  } catch {
    return false;
  }
};

export const hasSasToken = (url = "") => {
  try {
    const params = new URL(url).searchParams;
    return params.has("sig") && params.has("se") && params.has("sp");
  } catch {
    return false;
  }
};

const extractSignedUrl = (payload) => payload?.data?.signedUrl || payload?.data?.sasUrl || payload?.data?.url || payload?.signedUrl || payload?.sasUrl || payload?.url || "";

export const getSecurePreviewUrl = async (rawUrl, expiresInMinutes = DEFAULT_PREVIEW_EXPIRY_MINUTES) => {
  const url = buildFileUrl(rawUrl);
  if (!url) throw new Error("File URL is unavailable");
  if (!isAzureBlobUrl(url) || hasSasToken(url)) return url;

  const response = await api.post(environment.blobSasUrlEndpoint, {
    url,
    expiresInMinutes,
  });

  const signedUrl = extractSignedUrl(response.data);
  if (!signedUrl) throw new Error("Preview URL was not returned");
  return signedUrl;
};

export const openSecureFileUrl = async (rawUrl) => {
  const previewWindow = window.open("about:blank", "_blank");

  try {
    if (!previewWindow) {
      throw new Error("Preview popup was blocked");
    }

    previewWindow.opener = null;
    const signedUrl = await getSecurePreviewUrl(rawUrl);
    previewWindow.location.replace(signedUrl);
    return true;
  } catch (error) {
    previewWindow?.close();
    console.error("Unable to open secure file preview:", error);
    return false;
  }
};
